import { _SHARED_GLOBALS } from './config';

export const environment = {
  production: true,
  stripePublishableKey: 'pk_live_FhGRKGjmFFAOSLO25AvOEVC600Lc7kDCL8',
  ..._SHARED_GLOBALS,
};
